import React, { useState, useEffect, useCallback } from 'react';
import { Col, Table, Row } from 'react-bootstrap';
import Steps from 'rc-steps';
import 'rc-steps/assets/index.css';
import { useTranslation } from 'react-i18next';
import { Status } from '../util/Status';
import { makeKey } from '../hooks/useConvertForTranslationKey';
const icons = {
  finish: /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "done"),
  error: /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "close")
};
export const ClaimState = _ref => {
  let {
    tasks,
    markTaskComplete,
    claimGroup
  } = _ref;
  const [currentClaimTaskIndex, setCurrentClaimTaskIndex] = useState(0);
  const [currentUserTaskIndex, setCurrentUserTaskIndex] = useState(0);
  const [stepsItems, setStepsItems] = useState([]);
  const {
    t
  } = useTranslation();
  const getCurrentTaskIndex = useCallback(() => {
    const index = tasks.findIndex(task => task.status === 'in_progress');
    if (index === -1) {
      const firstNotStartedIndex = tasks.findIndex(task => task.status === 'not_started');
      return firstNotStartedIndex === -1 ? tasks.length : firstNotStartedIndex;
    } else {
      return index;
    }
  }, [tasks]);
  useEffect(() => {
    const currentClaimTaskIndex = getCurrentTaskIndex();
    setCurrentClaimTaskIndex(currentClaimTaskIndex);
    currentClaimTaskIndex === tasks.length ? setCurrentUserTaskIndex(currentClaimTaskIndex - 1) : setCurrentUserTaskIndex(currentClaimTaskIndex);
  }, [tasks, currentClaimTaskIndex, getCurrentTaskIndex]);
  useEffect(() => {
    const stepsItems = tasks.map((task, index) => {
      return {
        // using description to highlight task selected by the user
        title: currentUserTaskIndex === index ? '' : t(makeKey(task.category_title)),
        description: currentUserTaskIndex === index ? t(makeKey(task.category_title)) : '',
        status: index < currentClaimTaskIndex ? 'finish' : index === currentClaimTaskIndex ? 'process' : 'wait'
      };
    });
    setStepsItems(stepsItems);
  }, [tasks, currentClaimTaskIndex, currentUserTaskIndex]);
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 2,
    className: "border-end border-light"
  }, /*#__PURE__*/React.createElement(Steps, {
    current: currentUserTaskIndex,
    direction: "vertical",
    items: stepsItems,
    icons: icons,
    onChange: stepIndex => setCurrentUserTaskIndex(stepIndex)
  })), /*#__PURE__*/React.createElement(Col, {
    md: 10
  }, currentUserTaskIndex > currentClaimTaskIndex && /*#__PURE__*/React.createElement("div", {
    className: "alert alert-warning",
    role: "alert"
  }, t('you_have_unfinished_previous_tasks')), /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, t('task_name')), /*#__PURE__*/React.createElement("th", null, t('status')), markTaskComplete && /*#__PURE__*/React.createElement("th", null, t('actions')))), /*#__PURE__*/React.createElement("tbody", null, tasks[currentUserTaskIndex] && tasks[currentUserTaskIndex].tasks.map((task, taskIndex) => /*#__PURE__*/React.createElement("tr", {
    key: taskIndex
  }, /*#__PURE__*/React.createElement("td", null, t(makeKey(task.title))), /*#__PURE__*/React.createElement("td", null, task.completed ? /*#__PURE__*/React.createElement(Status, {
    status: "success",
    text: t('validated')
  }) : /*#__PURE__*/React.createElement(Status, {
    status: t('warning'),
    text: t('pending')
  })), /*#__PURE__*/React.createElement("td", null, markTaskComplete && /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer mt-2 mb-2",
    key: taskIndex,
    onClick: () => markTaskComplete(tasks[currentUserTaskIndex], currentUserTaskIndex, taskIndex, claimGroup)
  }, /*#__PURE__*/React.createElement("span", {
    className: "mx-1"
  }, task.completed ? /*#__PURE__*/React.createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "close"), " ", t('cancel_task')) : /*#__PURE__*/React.createElement("span", {
    className: "text-primary"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "done"), " ", t('validate_task')))))))))));
};